import React, { useState } from 'react';
import { FaSearch } from 'react-icons/fa';
import './SearchBox.css'

type SearchBoxProps = {
    onSearch: (query: string) => void;
    className?: string;
    searchQuery: string;
};

const SearchBox: React.FC<SearchBoxProps> = ({ onSearch, className, searchQuery }) => {
    const [searchTerm, setSearchTerm] = useState(searchQuery);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setSearchTerm(value);
        onSearch(value);
    };

    return (
        <div className={`search-input-wrapper ${className ?? ''}`}>
            <input
                type="text"
                placeholder="Rechercher par nom..."
                value={searchTerm}
                onChange={handleInputChange}
                className="search-input"
            />
            <FaSearch className="search-icon" />
        </div>
    );
};

export default SearchBox;
